import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, ApiError } from "./api";

export type Me = { id: string; username: string };

export const meQueryKey = ["me"] as const;

export function useMe() {
  return useQuery<Me | null>({
    queryKey: meQueryKey,
    queryFn: async () => {
      try {
        return await api.get<Me>("/api/me");
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 60_000,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { username: string; password: string }) =>
      api.post<{ ok: true; username: string }>("/api/login", vars),
    onSuccess: () => qc.invalidateQueries({ queryKey: meQueryKey }),
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<{ ok: true }>("/api/logout"),
    onSuccess: () => {
      qc.setQueryData(meQueryKey, null);
      qc.clear();
    },
  });
}

export function useSetup() {
  return useMutation({
    mutationFn: (vars: { token: string; password: string }) =>
      api.post<{ ok: true; username: string }>("/api/setup", vars),
  });
}
